module.exports = __webpack_public_path__ + "img/weather_05.f44f0990.png";